import PropTypes from 'prop-types';
import RemoveButton from './RemoveButton';

const AccountsItemEmptyTile = ({ id, removeSet }) => (
  <tr>
    <td>{id}</td>
    <td colSpan={5} className="text-center">
      <span>No Accounts available in this Set.</span>
    </td>
    <td>
      <RemoveButton onClick={removeSet} />
    </td>
  </tr>
);

AccountsItemEmptyTile.propTypes = {
  id: PropTypes.number.isRequired,
  removeSet: PropTypes.func.isRequired,
};

export default AccountsItemEmptyTile;
